/* eslint-disable react/prop-types */
import * as React from 'react';
import {
  createStackNavigator,
  CardStyleInterpolators,
} from '@react-navigation/stack';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { setTitleHeader, setDefaultStackOption } from '@global/helpers';
import { isWeb, isMobileWeb } from '@global/screens';

import BackButton from '@components/navbar/BackButton';
import NotificationSettingButton from '@components/navbar/NotificationSettingButton';

import GuideBookScreen from '@/screens/guide-book/GuideBookScreen';

const Stack = createStackNavigator();

const GuideBookNavigator = () => {
  const insets = useSafeAreaInsets();

  return (
    <Stack.Navigator
      initialRouteName="GuideBookScreen"
      screenOptions={(props) => ({
        headerLeft: () =>
          isMobileWeb ? (
            <BackButton
              {...props}
              notUseLastRoute={true}
              onPress={() => props.navigation.navigate('HomeNavigator')}
            />
          ) : (
            <BackButton {...props} customBack={{ screen: 'HomeNavigator' }} />
          ),
        headerRight: () =>
          isWeb ? <NotificationSettingButton {...props} /> : null,
        ...setDefaultStackOption(insets, CardStyleInterpolators),
        ...(!isWeb && !isMobileWeb
          ? {
              headerTitleStyle: {
                color: '#FFFFFF',
                fontFamily: 'figtree-medium',
                fontSize: 14,
                marginLeft: -20,
              },
            }
          : {}),
      })}>
      <Stack.Screen
        name="GuideBookScreen"
        component={GuideBookScreen}
        options={{
          title: setTitleHeader('Guide Book'),
        }}
      />
    </Stack.Navigator>
  );
};

export default GuideBookNavigator;
